import React from 'react';
import { Col, Row, ModalFooter, Card, CardBody, Badge } from 'reactstrap';
import CommonModal from '../../Components/Modals/modal';
import { Btn } from '../../AbstractElements';

const ScorecardModal = ({ isOpen, toggle, attempt }) => {
  const responses = attempt.rawAttempt?.responses || [];
  const correctCount = attempt.correctAnswers;
  const incorrectCount = attempt.incorrectAnswers;
  const totalQuestions = responses.length;
  const skippedCount = totalQuestions - (correctCount + incorrectCount);

  return (
    <CommonModal
      isOpen={isOpen}
      title={`Scorecard: ${attempt.studentName}`}
      toggler={toggle}
      size="lg"
    >
      <div className="p-4">
        {/* Exam Header Details */}
        <div className="mb-4 text-center">
          <h4>{attempt.examTitle}</h4>
          <span className="text-muted">{attempt.examType}</span>
        </div>

        {/* Stats Section */}
        <Row className="mb-4">
          <Col md="3" sm="6" className="text-center mb-2">
            <Card className="bg-light-primary m-0">
              <CardBody className="p-3">
                <h5 className="mb-1 font-primary">{attempt.score} / {attempt.maxScore}</h5>
                <span className="text-muted text-uppercase font-xs">Total Score</span>
              </CardBody>
            </Card>
          </Col>
          <Col md="3" sm="6" className="text-center mb-2">
            <Card className="bg-light-success m-0">
              <CardBody className="p-3">
                <h5 className="mb-1 font-success">{correctCount}</h5>
                <span className="text-muted text-uppercase font-xs">Correct</span>
              </CardBody>
            </Card>
          </Col>
          <Col md="3" sm="6" className="text-center mb-2">
            <Card className="bg-light-danger m-0">
              <CardBody className="p-3">
                <h5 className="mb-1 font-danger">{incorrectCount}</h5>
                <span className="text-muted text-uppercase font-xs">Incorrect</span>
              </CardBody>
            </Card>
          </Col>
          <Col md="3" sm="6" className="text-center mb-2">
            <Card className="bg-light-warning m-0">
              <CardBody className="p-3">
                <h5 className="mb-1 font-warning">{skippedCount}</h5>
                <span className="text-muted text-uppercase font-xs">Skipped</span>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <hr />

        {/* Responses / Questions Breakdown */}
        <h5 className="mb-3">Question Breakdown</h5>
        <div className="question-list-container" style={{ maxHeight: '400px', overflowY: 'auto', paddingRight: '10px' }}>
          {responses.length === 0 ? (
            <p className="text-center text-muted">No responses captured for this attempt.</p>
          ) : (
            responses.map((resp, idx) => {
              const q = resp.questionId;
              const isCorrect = resp.isCorrect;
              const selectedOpt = resp.selectedAnswer;
              const correctOpt = q?.correctAnswer;
              const questionText = q?.questionEnglish || q?.questionBengali || 'Question details unavailable.';

              return (
                <div key={idx} className="mb-4 p-3 border rounded">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="font-weight-bold d-flex align-items-start gap-2 text-dark flex-grow-1">
                      <strong>Q{idx + 1}.</strong>
                      <div dangerouslySetInnerHTML={{ __html: questionText }} />
                    </div>
                    <span>
                      {isCorrect ? (
                        <Badge color="success">Correct</Badge>
                      ) : selectedOpt ? (
                        <Badge color="danger">Incorrect</Badge>
                      ) : (
                        <Badge color="secondary">Skipped</Badge>
                      )}
                    </span>
                  </div>

                  {q && (
                    <div className="ps-3">
                      {[1, 2, 3, 4].map(optNum => {
                        const optText = q[`answer${optNum}English`] || q[`answer${optNum}Bengali`];
                        if (!optText) return null;

                        let optionClass = 'p-2 mb-1 rounded border ';
                        if (optNum === correctOpt) {
                          optionClass += 'bg-light-success border-success font-success text-success';
                        } else if (optNum === selectedOpt && !isCorrect) {
                          optionClass += 'bg-light-danger border-danger font-danger text-danger';
                        } else {
                          optionClass += 'bg-light text-dark border-light';
                        }

                        return (
                          <div key={optNum} className={optionClass} style={{ fontSize: '14px' }}>
                            <div className="d-flex align-items-center flex-wrap">
                              <span className="me-2 font-bold">{String.fromCharCode(64 + optNum)}.</span>
                              <span dangerouslySetInnerHTML={{ __html: optText }} />
                              {optNum === correctOpt && <span className="ms-2 font-success font-weight-bold">✔ (Correct Answer)</span>}
                              {optNum === selectedOpt && optNum !== correctOpt && <span className="ms-2 font-danger font-weight-bold">✘ (Your Selection)</span>}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
      <ModalFooter className="justify-content-center">
        <Btn attrBtn={{ color: 'secondary', onClick: toggle }}>Close</Btn>
      </ModalFooter>
    </CommonModal>
  );
};

export default ScorecardModal;
